import React from 'react'
import NestedHoverMenu from './NestedHoverMenu'

const ThreeDotHoverMenu = ({ menuOptions }) => {
  return (
    <NestedHoverMenu menuOptions={menuOptions}>
      {({ animateIn }) => {
        return <div className='hover-dots-circle' onMouseEnter={animateIn} />
      }}
    </NestedHoverMenu>
  )
}

export default ThreeDotHoverMenu
